import { useState } from 'react';

import type { WithInnerLayoutProps } from 'components/shared/CRUD/components/InnerPage/WithInnerLayout';
import type { ProtocolResponse } from 'generated/index';

/**
 * The protocol whose detail view is open, shown as the admin tables' inner layout (the table
 * switcher hides, as on Planeenheden). Looked up in the list by id, so an edit shows up as soon as
 * the list is refetched, and a protocol that disappears from it closes its detail view. The list
 * carries each protocol's rules, so the detail view needs no call of its own.
 */
export const useSelectedProtocol = (
  protocols: ProtocolResponse[],
  { isInnerLayoutOpen, setIsInnerLayoutOpen }: WithInnerLayoutProps
) => {
  const [selectedProtocolId, setSelectedProtocolId] = useState<string | null>(
    null
  );
  const selectedProtocol = isInnerLayoutOpen
    ? protocols.find(({ id }) => id === selectedProtocolId)
    : undefined;

  return {
    selectedProtocol,
    openProtocol: (protocolId: string) => {
      setSelectedProtocolId(protocolId);
      setIsInnerLayoutOpen(true);
    },
    closeProtocol: () => setIsInnerLayoutOpen(false)
  };
};
